export default "__VITE_PUBLIC_ASSET__bd9f213b__"